module.exports = __webpack_public_path__ + "img/tiktok-icon-active.0da09925.png";